import { IonSpinner, IonToast } from '@ionic/react';
import { useHistory } from 'react-router';
import { useSendUserFeedbackMutation } from '../api/UserApi';
import { FormTextarea } from '../components/Forms/FormTextarea';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconArrowBack, IconFeedback, IconUpload } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { SiteLogoBanner } from '../components/SiteLogoBanner';
import { FormValidationRules, useFormValues } from '../hooks/useFormValues';
import styles from './SendUserFeedback.module.css';
type UserFeedback = {
	feedback: string;
};

const feedbackRules: FormValidationRules<UserFeedback> = {
	feedback: {
		rules: {
			required: { value: true, message: 'Please enter some feedback' },
			minLength: { value: 10, message: 'Please enter at least {value} characters' },
			maxLength: { value: 1000, message: 'Please enter at most {value} characters' }
		}
	}
};

const EMPTY_FEEDBACK = {
	feedback: ''
};
export const SendUserFeedback = () => {
	const history = useHistory();
	const [trigger, results] = useSendUserFeedbackMutation();
	const { setValues, formValues, formSuccess } = useFormValues<UserFeedback>(feedbackRules, EMPTY_FEEDBACK);
	function submit() {
		if (formValues && formValues.feedback) {
			trigger(formValues.feedback.value);
		}
	}

	return (
		<QuirkIonPage name="Send Feedback">
			<Header
				title="Send Feedback"
				left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />}
			/>

			<QuirkIonContent flush>
				<>
					<SiteLogoBanner />
					<div className={styles.fieldsContainer}>
						{!results.isSuccess ? (
							<>
								<FormTextarea
									setValues={setValues}
									id="feedback"
									label="Question, comment or suggestion"
									field={formValues?.feedback}
									placeholder="Please type your question, comment or suggestion"
								/>
								<IconButton
									label={results.isLoading ? <IonSpinner /> : 'Send'}
									disabled={!formSuccess}
									icon={!results.isLoading ? <IconFeedback /> : <IconUpload />}
									onClick={() => submit()}
								/>
							</>
						) : null}
					</div>
				</>
			</QuirkIonContent>
			<IonToast
				isOpen={results.isSuccess}
				color="success"
				position="top"
				message="Thank you for your feedback!"
				duration={2000}
			/>
			<IonToast
				isOpen={results.isError}
				message="There was a problem sending your feedback"
				color="danger"
				position="top"
				duration={2000}
			/>
		</QuirkIonPage>
	);
};
